  <template>
 <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="session-modal">
          <div class="content-container">
            <p class="session-modal-title">Oops</p>
            <p class="session-modal-p">Your session has expired.</p>
            <p class="session-modal-p">Please log-in again.</p>
            <button class="session-confirm" @click="onClose">Ok</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </template>
  <script>
  export default {
    name: 'loading',
    props: ['onClose'],
  }
  </script>
<style scoped lang="less">
@import "../../assets/css/refreshSession.less";
</style>



// WEBPACK FOOTER //
// src/view/Modal/refreshSession.vue